export class EquipmentOption {
    static fromPlainObjectList(objList) {
        const equipmentOptionsList = [];
        if (objList && Array.isArray(objList)) {
            for (const obj of objList) {
                equipmentOptionsList.push(new EquipmentOption(obj.code, obj.description, obj.currentlyInstalled, obj.installedExWorks));
            }
        }
        return equipmentOptionsList;
    }
    static fromRawData(specialEquipmentList) {
        const equipmentOptions = [];
        for (const equipment of specialEquipmentList.specialEquipment) {
            if (equipment.saart !== 'L' && equipment.saart !== 'P') {
                const option = new EquipmentOption(equipment.sacode, equipment.description, equipment.installedCurrent, equipment.installedDOM);
                equipmentOptions.push(option);
            }
        }
        return equipmentOptions;
    }
    static extractFirstFromRawData(specialEquipmentList, saart) {
        for (const equipment of specialEquipmentList.specialEquipment) {
            if (equipment.saart === saart) {
                return new EquipmentOption(equipment.sacode, equipment.description, equipment.installedCurrent, equipment.installedDOM);
            }
        }
        return null;
    }
    constructor(code, description, currentlyInstalled, installedExWorks) {
        this.code = code;
        this.description = description;
        this.currentlyInstalled = currentlyInstalled;
        this.installedExWorks = installedExWorks;
    }
    getCode() {
        return this.code;
    }
    getDescription() {
        return this.description;
    }
    isCurrentlyInstalled() {
        return this.currentlyInstalled;
    }
    isInstalledExWorks() {
        return this.installedExWorks;
    }
}
//# sourceMappingURL=equipmentOption.js.map